import Axios from 'axios';
import { HAS_ERRORS, RESET_ERROR_HANDLER } from './actionTypes';


export const errorHandlerAction = (errorHandler) => dispatch => {
    // console.log("ErrorActions errorHandlerAction errorHandler:" + errorHandler);
    try {
        dispatch({
            type: HAS_ERRORS,
            payload: errorHandler
        })

    } catch (err){
        console.log('ErrorActions errorHandlerAction failed : ' + err) 
    }
};

export const ResetErrorHandlerAction = () => dispatch => {
    try {
        dispatch({
            type: RESET_ERROR_HANDLER
        })

    } catch (err){
        console.log('ErrorActions resetErrorHandlerAction failed : ' + err) 
    }
};